import { Button, Popconfirm } from 'antd';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';

export function getBranchSettingsTable(handleAction) {
  return [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      sorter: (a, b) => a.id - b.id,
      fixed: 'left',
    },
    {
      title: 'Branch Name',
      dataIndex: 'branch_name',
      key: 'branch_name',
      sorter: (a, b) => a.branch_name.localeCompare(b.branch_name),
    },
    {
      title: 'Branch Address',
      dataIndex: 'branch_address',
      key: 'branch_address',
      sorter: (a, b) => a.branch_address.localeCompare(b.branch_address),
    },
    {
      title: 'Contact',
      dataIndex: 'branch_contactNumber',
      key: 'branch_contactNumber',
      sorter: (a, b) => a.branch_contactNumber.localeCompare(b.branch_contactNumber),
    },
    {
        title: 'Customer Care Hotline',
        dataIndex: 'cust_care_number',
        key: 'cust_care_number',
        sorter: (a, b) => a.cust_care_number.localeCompare(b.cust_care_number),
      },
      {
        title: 'Messenger',
        dataIndex: 'fb_messenger',
        key: 'fb_messenger',
        sorter: (a, b) => a.fb_messenger.localeCompare(b.fb_messenger),
      },
  
  
 
  ];
}
